import { FILTER_ALL_VALUE } from 'shared/constants/offersHistory';
import { IOffersHistory } from 'shared/types/offersHistory';

export const initialState: IOffersHistory = {
  data: {
    listing: {
      isFetching: false,
      isError: false,
      data: null,
      isLoadMore: false,
    },
    listingSpoiler: {
      isFetching: false,
      isError: false,
      data: null,
      isLoadMore: false,
    },
    offers: {
      isFetching: false,
      isError: false,
      isAuthError: false,
      isLoadMore: false,
      data: {},
    },
  },
  roomsFilterActiveValue: FILTER_ALL_VALUE,
  statusFilterActiveValue: FILTER_ALL_VALUE,
  categoriesFilterActiveValue: FILTER_ALL_VALUE,
  typeFilterActiveValue: undefined,
  page: 1,
  resultsOnPage: 10,
  activeOfferId: null,
  isFiltersChanged: false,
  viewedOffers: [],
  defaultFilters: {},
  offersHistoryExists: undefined,
};
